
    <div class="br-confirm-dialog">
      <header class="br-dialog-header">
        <h2 class="br-dialog-title">{{ data.title }}</h2>
      </header>
      <mat-dialog-content class="br-dialog-body br-confirm-dialog__body">
        <p>{{ data.message }}</p>
      </mat-dialog-content>
      <footer class="br-dialog-footer">
        <button
            type="button"
            class="br-btn br-btn--outline-secondary br-btn--sm"
            [mat-dialog-close]="false">
          {{ data.cancelLabel || 'Cancel' }}
        </button>
        <button
            type="button"
            class="br-btn br-btn--sm"
            [class.br-btn--primary]="!data.danger"
            [class.br-btn--danger]="data.danger"
            [mat-dialog-close]="true">
          {{ data.confirmLabel || 'Confirm' }}
        </button>
      </footer>
    </div>
